

import React,{useState,useEffect} from 'react'
import { BoxFormula } from '../boxFormula/BoxFormula';
export const BoxInputComment = (props) => {
    const [images, setImage] = useState(props.images || []);

    // Neu la comment con se co parent id
    const background = props.comment_id ? { card: '#fff', bgTXT: '#eaf0f5' } : false; 

    // api upload image
    const uploadFileImage = (dataFile) =>{
         
    }

    return (
        <div className="userBlock cardBg boxRep boxInput">
            <img src={props.avatar} alt="" className="avatar" />
            <div className="userInfo">
                <div className="content">
                    <BoxFormula is_mod_hoidap={props.is_mod_hoidap} item_id={props.item_id} item_type={props.item_type} item_action={props.item_action} pushCmt={(new_cmt => props.pushCmt(new_cmt))}comment_id={props.comment_id} bg={background} user_id={props.user_id}/>
                </div>
            </div>
        </div>
    )
}
